export default {"src":"/_next/static/media/rightMark.9aa9435d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};